import React from "react";

interface ConfirmDeleteModalProps {
  message?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  message = "Are you sure you want to delete this?",
  onConfirm,
  onCancel,
}) => {
  return (
      <div className="fixed inset-0 bg-transparent flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 p-4 rounded shadow-lg w-80">
        <p className="text-gray-800 dark:text-white mb-4">{message}</p>
        <div className="flex justify-end space-x-2">
          <button
            type="button" // <-- Prevents page refresh
            className="px-3 py-1 bg-gray-300 rounded hover:bg-gray-400 text-gray-800"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="button" // <-- Prevents page refresh
            className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600"
            onClick={onConfirm}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
